import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Delivery } from 'src/app/models/delivery.schema';

@Component({
  selector: 'app-show-signature',
  templateUrl: './show-signature.component.html',
  styleUrls: ['./show-signature.component.scss']
})
export class ShowSignatureComponent implements OnInit {

  delivery: Delivery;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { delivery: Delivery },
  ) { 
    this.delivery = this.data.delivery;
  }

  get fullName(): string {
    if (this.delivery?.receiverType?.toLowerCase() === 'other' || this.delivery?.receiverType?.toLowerCase() === 'concierge') {
      return `${this.delivery?.receiverName} ${this.delivery?.receiverSurname}`;
    } else {
      return `${this.delivery?.surname} ${this.delivery?.name}`;
    }
  }

  ngOnInit(): void {
  }

}
